import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/empleado/getEgresosEmpleado.php';

export default function getEgresosEmpleado({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}